<style lang="stylus" scoped>
.greyBackSpace {
  background-color: #F2F2F2;
  padding: 1.15rem;

  // span {
  // font-size: 12px;
  // }
  .reviewSelec {
    border-style: solid;
    border-radius: 50px;
    border-color: #fec627;
    padding: 4px 5px 4px 12px;
    background-color: #fec627;
    font-size: 14px;
    font-weight: 600;
    color: black;
    height: 100%;
    align-items: center;

    i {
      font-size: 16px;
    }
  }
}

.selectedCourses {
  background-color: #747474;
  border-radius: 2px 2px 0px 0px;
  color: white;

  strong {
    color: white;
    padding-left: 20px;
    font-weight: bolder;
  }
}

.inactiveReviewButton {
  span {
    border: 2px solid;
    border-radius: 50px;
    border-color: #989898;
    padding: 9px 0px 10px 18px;
    color: #989898;
    font-size: 16px;
    font-weight: 500;
  }
}

.mytooltip .mytext {
  font-size: 14px;
  font-weight: bold;
  visibility: hidden;
  background-color: black;
  color: #fff;
  z-index: 1;
  bottom: 135%;
  left: -27%;
  margin-left: -90px;
  text-align: center;
  border-radius: 6px;
  padding: 12px 6px;
  position: absolute;
}

.mytooltip {
  font-weight: bold;
  position: relative;
  display: inline-block;
}

.mytooltip .mytext:after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -10px;
  border-width: 7px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}

.mytooltip:hover .mytext {
  visibility: visible;
}

@media (min-width: 300px) and (max-width: 320px) {
  .mytooltip .mytext {
    width: 288px;
    left: -22%;
    padding: 17px 10px;
  }

  .mytooltip .mytext:after {
    left: 56%;
  }
}

@media (min-width: 321px) and (max-width: 385px) {
  .mytooltip .mytext {
    width: 288px;
    left: 60%;
    padding: 17px 10px;
  }

  .mytooltip .mytext:after {
    left: 30%;
  }
}

@media (min-width: 386px) and (max-width: 480px) {
  .mytooltip .mytext {
    width: 288px;
    left: -94%;
    padding: 17px 10px;
  }

  .mytooltip .mytext:after {
    left: 78%;
  }
}

@media (min-width: 481px) and (max-width: 620px) {
  .mytooltip .mytext {
    width: 288px;
    left: 35%;
    padding: 17px 10px;
  }

  .mytooltip .mytext:after {
    left: 38%;
  }
}

@media (min-width: 620px) {
  .mytooltip .mytext {
    width: 340px;
  }
}

@media (max-width: 768px) {
  .v-expansion-panel-text__wrapper {
    padding: 0px !important;
  }
}

.selected-course-note {
  font-size: 14px;
  margin-top: 3px;
  font-weight: normal;
  color: #747474;
}
</style>
<template>
  <div>
    <div class="d-none d-md-block enrollment-section" style="border: 1px solid rgb(0, 0, 0, 0.05)">
      <div class="selectedCourses" style="padding-top: 10px; padding-bottom: 10px">
        <v-icon dark style="font-size: 32px; margin-left: 25px">mdi-calendar</v-icon>

        <strong style="font-weight: 500; font-size: 18px">Selected Courses</strong>
      </div>
      <div class="greyBackSpace" style="margin: 1.15rem" v-if="selectedCourses.length === 0">
        <v-row>
          <v-col cols="12">
            <p style="font-size: 14px; font-weight: normal; padding-left: 11px">
              Select your courses to finalize your schedule and continue registration
            </p>
          </v-col>
          <v-col cols="12" md="10">
            <div class="inactiveReviewButton" style="padding-top: 30px">
              <!-- <span>
              Review Selection
              <v-icon left style="padding-left: 8px;">mdi-arrow-right</v-icon>
            </span>-->
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-else class="greyBackSpace" style="margin: 1.15rem">
        <v-row
          v-for="(course, i) in selectedCourses"
          v-bind:key="i"
          style="border-bottom: 1px solid white; margin-bottom: 1rem"
        >
          <v-col cols="12" sm="11" md="11" lg="11" xl="11" class="py-0 px-0">
            <h5>{{ course._coursePrefixDisplayLabel || course._coursePrefix }}</h5>
            <strong style="font-size: 14px; font-weight: 500">{{ course._courseName }}</strong>
          </v-col>
          <v-col cols="6" sm="5" md="5" class="px-0" style="font-size: 10px; padding-bottom: 14px; font-weight: normal">
            <span>Starts {{ getStartDate(course) }}</span>
          </v-col>
          <v-col cols="5" sm="5" md="5" style="font-size: 10px; padding-bottom: 14px; font-weight: normal">
            <span>{{ course._asuCredits + ' Credits' }}</span>
          </v-col>
          <v-col cols="1" sm="1" md="1" style="font-size: 8px">
            <v-icon
              style="font-size: 14px"
              class="fas fa-trash-alt"
              @click="
                removeCourse(
                  course._coursePrefix,
                  course._courseStartDate,
                  course._courseOfferingId,
                  course._courseName
                )
              "
            />
          </v-col>

          <v-col v-if="shouldShowNonBEWarning(course)" style="padding-left: 8px" class="selected-course-note">
            <v-col cols="1" sm="1" md="1" style="display: inline">
              <v-icon size="15px" color="#747474" style="margin-bottom: 2px">mdi-alert</v-icon>
            </v-col>

            <b>Please note: </b>This course is not currently covered under your partnership. Fees may apply.
          </v-col>
        </v-row>
        <v-row style="padding-top: 10px" class="mt-2">
          <v-col
            cols="6"
            sm="5"
            md="4"
            lg="4"
            xl="4"
            class="px-0"
            style="font-size: 10px; font-weight: 600; color: #777777"
          >
            TOTAL
            <h5 style="margin-top: 0px; font-size: 13px; color: black">{{ totalCredits }} Credits</h5>
          </v-col>
          <v-col cols="6" md="8" lg="8" xl="8" class="px-0">
            <div style="padding-right: 10px; height: 100%" class="px-0">
              <div class="reviewSelec" @click="next()" style="cursor: pointer; display: flex">
                Add to schedule
                <v-icon left style="color: black; position: relative; margin-right: 0px; padding: 0px 10px 0px 15px"
                  >mdi-arrow-right</v-icon
                >
              </div>
              <!-- </router-link> -->
            </div>
          </v-col>
        </v-row>
        <v-row v-if="shouldShowNote">
          <v-col cols="12" sm="10" md="10" style="padding-left: 8px" class="selected-course-note">
            <v-col cols="1" sm="1" md="1" style="display: inline" class="px-1 py-0">
              <v-icon color="#747474" style="font-size: 15px; margin-bottom: 2px" class="fas fa-exclamation-triangle" />
            </v-col>
            <b>Please note: </b>When you add a course to your schedule, you aren't enrolled until you pay the course
            enrollment fee. Following completion of the course, you can choose to add it to your ASU transcript for an
            additional fee.
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="d-flex d-md-none">
      <v-expansion-panels style="position: fixed; bottom: 0px; left: 0px; z-index: 3">
        <v-expansion-panel>
          <!-- Hide default right-aligned chevron -->
          <v-expansion-panel-title
            :hide-actions="true"
            v-slot="{ expanded }"
            style="background-color: #747474; font-size: 20px"
          >
            <div class="d-flex align-center w-100" style="gap: 10px; color: #fff">
              <v-icon size="28" class="ml-3" @click.stop="whiteOut = !whiteOut">mdi-calendar</v-icon>

              <strong @click.stop="whiteOut = !whiteOut">Selected Courses</strong>

              <!-- Your chevron, tight to the label -->
              <v-icon
                size="30"
                class="ml-1"
                :style="{
                  transition: 'transform 150ms',
                  transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                mdi-menu-up
              </v-icon>
            </div>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <div class="greyBackSpace" v-if="selectedCourses.length === 0">
              <v-row>
                <v-col cols="12">
                  <p style="font-size: 14px; font-weight: normal; padding-left: 11px">
                    Select your courses to finalize your schedule and continue registration
                  </p>
                </v-col>
                <v-col cols="12" md="10">
                  <div class="inactiveReviewButton" style="padding-top: 30px">
                    <!-- <span>
              Review Selection
              <v-icon left style="padding-left: 8px;">mdi-arrow-right</v-icon>
            </span>-->
                  </div>
                </v-col>
              </v-row>
            </div>
            <div v-else>
              <div
                class="greyBackSpace"
                style="overflow-y: scroll; overflow-x: hidden; height: 462px; padding-bottom: 60px"
              >
                <v-row
                  v-for="(course, i) in selectedCourses"
                  v-bind:key="i"
                  style="border-bottom: 3px solid white; margin-bottom: 1rem"
                >
                  <v-col cols="12" sm="11" md="11" class="px-0">
                    <h5>{{ course._coursePrefixDisplayLabel || course._coursePrefix }}</h5>
                    <strong style="font-size: 14px; font-weight: 500">{{ course._courseName }}</strong>
                  </v-col>
                  <v-col
                    cols="6"
                    sm="5"
                    md="5"
                    class="px-0"
                    style="font-size: 10px; padding-bottom: 14px; font-weight: normal"
                  >
                    <span>Starts {{ getStartDate(course) }}</span>
                  </v-col>
                  <v-col
                    cols="5"
                    sm="5"
                    md="5"
                    class="px-0"
                    style="font-size: 10px; padding-bottom: 14px; font-weight: normal"
                  >
                    <span>{{ course._asuCredits + ' Credits' }}</span>
                  </v-col>
                  <v-col cols="1" sm="1" md="1" style="font-size: 10px; padding-bottom: 14px">
                    <v-icon
                      style="font-size: 14px; margin-bottom: 4px"
                      class="fas fa-trash-alt"
                      @click="
                        removeCourse(
                          course._coursePrefix,
                          course._courseStartDate,
                          course._courseOfferingId,
                          course._courseName
                        )
                      "
                    />
                  </v-col>

                  <v-col v-if="shouldShowNonBEWarning(course)" style="padding-left: 8px" class="selected-course-note">
                    <v-col cols="1" sm="1" md="1" style="display: inline">
                      <v-icon size="15px" color="#747474" style="margin-bottom: 2px">mdi-alert</v-icon>
                    </v-col>

                    <b>Please note: </b>This course is not currently covered under your partnership. Fees may apply.
                  </v-col>
                </v-row>
                <v-row justify="space-between" style="padding-top: 10px">
                  <v-col
                    cols="3"
                    sm="3"
                    md="5"
                    lg="4"
                    xl="4"
                    class="px-0"
                    style="font-size: 10px; font-weight: 600; color: #777777"
                  >
                    TOTAL
                    <h5 style="margin-top: 0px; font-size: 13px; color: black">{{ totalCredits }} Credits</h5>
                  </v-col>
                  <v-col cols="8" sm="3" md="4" lg="4" xl="4" class="px-0">
                    <div style="padding-right: 10px; height: 100%">
                      <div class="reviewSelec" @click="next()" style="cursor: pointer; display: flex">
                        Add to schedule
                        <v-icon
                          left
                          style="color: black; position: relative; margin-right: 0px; padding: 0px 5px 0px 10px"
                          >mdi-arrow-right</v-icon
                        >
                      </div>
                      <!-- </router-link> -->
                    </div>
                  </v-col>
                </v-row>
                <v-row v-if="shouldShowNote" style="margin: 20px 0 10px 0; padding-bottom: 40px">
                  <v-col cols="12" sm="10" md="10" style="padding-left: 8px" class="selected-course-note">
                    <v-col cols="1" sm="1" md="1" style="display: inline">
                      <v-icon size="15px" color="#747474" style="margin-bottom: 2px">mdi-alert</v-icon>
                    </v-col>
                    <!-- <span class=""> -->
                    <b>Please note: </b>When you add a course to your schedule, you aren't enrolled until you pay the
                    course enrollment fee. Following completion of the course, you can choose to add it to your ASU
                    transcript for an additional fee.

                    <!-- <span class="mytooltip">
                    <span style="font-weight: bold; font-size: 14px; color: #292929; border-bottom: 2px solid rgb(253, 198, 59)">preview mode.</span>
                    <span class="mytext"
                      >Previewing a course means you’ll have access to the course materials and assignments, but you won’t receive academic credit for the
                      course.</span
                    >
                  </span> -->
                    <!-- </span> -->
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <!-- On Demand Warning Modal -->
    <on-demand-warning-modal
      :show="showOnDemandWarning"
      :course-name="selectedOnDemandCourse ? selectedOnDemandCourse._courseName : ''"
      :course-prefix="selectedOnDemandCourse ? selectedOnDemandCourse._coursePrefix : ''"
      :session-start-date="sessionBasedAlternative ? sessionBasedAlternative.startDate : ''"
      :session-end-date="sessionBasedAlternative ? sessionBasedAlternative.endDate : ''"
      @close="handleCloseModal"
      @continue-on-demand="handleContinueOnDemand"
      @enroll-in-session="handleEnrollInSession"
    />
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useUserStore } from '@/stores/user';

import { DataLayerMixin } from '../mixins/dataLayerMixin';
import { Helper } from '../mixins/helpers.js';
import { toIsoDateStr } from '@/utils/dateUtils';
import { getAttributionParams } from '@/util/param-persistence';
import OnDemandWarningModal from './OnDemandWarningModal.vue';

export default defineComponent({
  emits: ['isMoreThanTwoSessionBasedCoursesSelected', 'addCourse'],
  name: 'SelectedCourses',

  components: {
    OnDemandWarningModal
  },

  data() {
    return {
      whiteOut: false,
      reviewSelection: true,
      payButton: false,
      amount: '25$',
      length: '',
      onHoverAuditStatus: false,
      showOnDemandWarning: false,
      selectedOnDemandCourse: null,
      sessionBasedAlternative: null
    };
  },

  mixins: [DataLayerMixin, Helper],

  props: {
    selectedCourses: {
      type: Array
    },
    shouldShowNote: {
      type: Boolean
    },
    allCourses: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    totalCredits() {
      let i;
      let totalCredits = 0;
      for (i = 0; i < this.selectedCourses.length; i++) {
        totalCredits += parseInt(this.selectedCourses[i]._asuCredits);
      }
      return totalCredits;
    }
  },

  methods: {
    shouldShowNonBEWarning(course) {
      return (
        (course._courseType || '').toLowerCase() !== 'audit' &&
        !course._benefitsEligible &&
        course._partnerBenefitEligible
      );
    },
    next() {
      // Check if any selected course is on-demand
      const onDemandCourse = this.selectedCourses.find((course) => this.isOnDemandCourse(course));

      // If no on-demand courses selected, skip modal
      const userStore = useUserStore();
      if (!onDemandCourse || !userStore.apis.learnerData?._showModalForCourseAlternativeWhenODSelected) {
        this.proceedToCheckout();
        return;
      }

      // Find session-based alternative for the on-demand course
      const sessionAlternative = this.findSessionBasedAlternative(onDemandCourse);

      // If no session-based alternative exists, skip modal
      if (!sessionAlternative) {
        this.proceedToCheckout();
        return;
      }

      // Show modal only if on-demand course has session-based alternative
      this.selectedOnDemandCourse = onDemandCourse;
      this.sessionBasedAlternative = sessionAlternative;
      this.showOnDemandWarning = true;
    },

    proceedToCheckout() {
      // Start of data layer changes
      const userStore = useUserStore();
      const leSfContactId = userStore.apis?.learnerData?._contactId || userStore.apis?.learnerData?.contactId || '';
      const { campaign, partner } = getAttributionParams();

      const ecom = {
        event: 'add_to_cart',
        le_sf_contact_id: leSfContactId,
        campaign,
        partner,
        ecommerce: {
          currency: 'USD',
          value: 0,
          items: []
        }
      };

      this.selectedCourses.forEach((course) => {
        const item = {
          item_id: (course._coursePrefix + ' ' + course._courseName).toLowerCase(),
          item_name: (course._coursePrefix + ' ' + course._courseName).toLowerCase(),
          course_offering_id: course._courseOfferingId || '',
          course_name: course._courseName || '',
          course_prefix: course._coursePrefix || '',
          course_start_date: toIsoDateStr(course._courseStartDate),
          course_end_date: toIsoDateStr(course._courseEndDate),
          price: 25.0,
          quantity: 1
        };
        ecom.ecommerce.items.push(item);
      });

      ecom.ecommerce.value = ecom.ecommerce.items.length * 25.0;

      this.asuoDataLayerClick('ecommerceTags', '0', ecom);

      // End of data layer changes

      this.$emit('isMoreThanTwoSessionBasedCoursesSelected');
    },

    isOnDemandCourse(course) {
      const term = (course._term || '').toLowerCase();
      const courseType = (course._courseType || '').toLowerCase();

      return (
        term.includes('on-demand') ||
        term.includes('self paced') ||
        courseType === 'continuous' ||
        courseType.includes('on-demand')
      );
    },

    findSessionBasedAlternative(onDemandCourse) {
      // Use the allCourses prop passed from parent
      const allCourses = this.allCourses || [];

      // Find session-based courses with same prefix
      const sessionBasedCourses = allCourses.filter((course) => {
        return (
          course._coursePrefix === onDemandCourse._coursePrefix &&
          course._courseOfferingId !== onDemandCourse._courseOfferingId &&
          !this.isOnDemandCourse(course)
        );
      });

      if (sessionBasedCourses.length > 0) {
        // Get the first available session-based course
        const sessionCourse = sessionBasedCourses[0];

        return {
          startDate: this.formatDate(sessionCourse._courseStartDate || '2025-03-15'),
          endDate: this.formatDate(sessionCourse._courseEndDate || '2025-05-15'),
          coursePrefix: sessionCourse._coursePrefix,
          courseName: sessionCourse._courseName,
          courseOfferingId: sessionCourse._courseOfferingId,
          course: sessionCourse
        };
      }
      return null; // No session-based alternative found
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },

    handleContinueOnDemand() {
      this.showOnDemandWarning = false;
      this.proceedToCheckout();
    },

    handleEnrollInSession() {
      this.showOnDemandWarning = false;

      if (this.sessionBasedAlternative && this.sessionBasedAlternative.course) {
        // Remove the on-demand course
        this.removeCourse(
          this.selectedOnDemandCourse._coursePrefix,
          this.selectedOnDemandCourse._courseStartDate,
          this.selectedOnDemandCourse._courseOfferingId,
          this.selectedOnDemandCourse._courseName
        );

        // Add the session-based course
        this.$emit('addCourse', {
          coursePrefix: this.sessionBasedAlternative.course._coursePrefix,
          courseStartDate: this.sessionBasedAlternative.course._courseStartDate,
          courseOfferingId: this.sessionBasedAlternative.course._courseOfferingId,
          add: true
        });
      }
    },

    handleCloseModal() {
      this.showOnDemandWarning = false;
    },
    removeCourse(coursePrefix, courseStartDate, courseOfferingId, courseName) {
      // Clear previous ecommerce object
      if (window.dataLayer) {
        window.dataLayer.push({ ecommerce: null });
      }

      const userStore = useUserStore();
      const leSfContactId = userStore.apis?.learnerData?._contactId || userStore.apis?.learnerData?.contactId || '';
      const removedCourse = this.selectedCourses.find(
        (c) => String(c._courseOfferingId) === String(courseOfferingId) && c._coursePrefix === coursePrefix
      );

      const { campaign, partner } = getAttributionParams();

      //data layer
      const ecom = {
        event: 'remove_from_cart',
        le_sf_contact_id: leSfContactId,
        campaign,
        partner,
        ecommerce: {
          currency: 'USD',
          value: 25.0,
          items: [
            {
              item_id: (coursePrefix + ' ' + courseName).toLowerCase(),
              item_name: (coursePrefix + ' ' + courseName).toLowerCase(),
              course_offering_id: courseOfferingId || '',
              course_name: courseName || '',
              course_prefix: coursePrefix || '',
              course_start_date: toIsoDateStr(courseStartDate),
              course_end_date: toIsoDateStr(removedCourse?._courseEndDate),
              price: 25.0,
              quantity: 1
            }
          ]
        }
      };

      this.asuoDataLayerClick('ecommerceTags', '0', ecom);

      this.$emit('addCourse', {
        coursePrefix,
        courseStartDate,
        courseOfferingId,
        add: false
      });
    },
    getStartDate(course) {
      return (course._courseType === 'Continuous' && new Date(course._courseStartDate) <= new Date()) ||
        course._courseType === 'Audit'
        ? this.today()
        : course._courseStartDate;
    }
  }
});
</script>
